<template>
    <div class="white-list-box">
        <div class="page-header">
            <h2>核销白名单</h2>
            <div class="settings-section">
                <span class="setting-label">非白名单核销次数：{{whiteListData.whiteListConfig ? whiteListData.whiteListConfig.verify_limit : '--'}}次</span>
                <el-button type="text" class="" @click="openConfig">
                    <i class="el-icon-edit-outline"></i>
                </el-button>
            </div>
        </div>
        <div class="query-box">
            <div class="query-btn-box">
                <el-button type="primary" size="small" @click="openAdd" icon="el-icon-plus">新增白名单</el-button>
                <el-button type="danger" size="small" @click="batchDeleteData" icon="el-icon-delete" :disabled="!table.selectData || table.selectData.length == 0">批量删除</el-button>
            </div>
            <div class="query-input-box"> 
                <div style="display: flex; gap: 8px">
                    <div>
                        <!-- <span>状态：</span> -->
                        <el-select size="small" v-model="query.status" placeholder="请选择" class="query-select" clearable>
                            <el-option label="自动限制" value="2"></el-option>
                            <el-option label="启用" value="1"></el-option>
                            <el-option label="停用" value="0"></el-option>
                        </el-select>
                    </div>
                    
                    <el-input size="small" placeholder="请输入白名单IP" v-model="query.ip" class="query-input" clearable/>
                    <el-button type="primary" size="small" icon="el-icon-search" @click="getData" :disabled="whiteListData.loading">查询</el-button>
                </div>

                <!-- <el-input type="text" size="small" placeholder="请输入白名单IP" v-model="query.ip" class="query-input input-with-select">        
                    <el-select v-model="query.status" slot="prepend" placeholder="请选择">
                        <el-option label="自动限制" value="2"></el-option>
                        <el-option label="启用" value="1"></el-option>
                        <el-option label="停用" value="0"></el-option>
                    </el-select>           
                    <el-button slot="append" icon="el-icon-search" @click="getData"></el-button>
                </el-input> -->
            </div>
        </div>
        <div class="table-box">
            <el-table
                :data="table.tableData"
                style="width: 100%"
                @selection-change="handleSelectionChange"
                border
                stripe
            >
                <el-table-column type="selection" width="55"/>
                <el-table-column label="白名单IP" prop="ip_address"/>
                <el-table-column label="创建时间" prop="create_time" width="180"/>                
                <el-table-column label="状态" width="180">
                    <template slot-scope="scope">
                        <div>
                            <span class="mr10 status-tag" :style="{'color':scope.row.status_color}">{{scope.row.status == 1?'已启用':scope.row.status == 2?'自动限制':scope.row.status == 0?'已停用':''}}</span>
                            <el-button :disabled="whiteListData.loading" size="mini" :type="scope.row.status == 0?'primary': scope.row.status == 2?'success':'danger'" @click="updateStatus(scope.row)">{{scope.row.status == 1?'去停用':scope.row.status == 2?'加入白名单 ':scope.row.status == 0?'去启用':''}}</el-button>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="180"> 
                    <template slot-scope="scope">
                        <el-button size="small" type="text" @click="openEdit(scope.row)" icon="el-icon-edit-outline">编辑</el-button>
                        <el-popconfirm  title="确认删除该白名单?" @confirm="deleteData(scope.row)">
                            <el-button class="text-btn-danger ml20" slot="reference" size="small" type="text"  icon="el-icon-delete" :disabled="whiteListData.loading">删除</el-button>
                        </el-popconfirm>
                        
                    </template>
                </el-table-column>

            </el-table>
            <div class="flexX pageBox flexEnd">
                <el-pagination :disabled="whiteListData.loading" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query.page" :page-sizes="whiteListData.pageSizesArr"
                    :page-size="query.limit" layout="total, sizes, prev, pager, next" :total="whiteListData.total"></el-pagination>
            </div>
        </div>
        <div class="dialog-box">
            <AddDialog v-if="dialog.addVisible" :dialogVisible="dialog.addVisible" title="新增白名单" :whiteListData="dialog.item" @sure="sure" @close="close" :loading="dialog.loading"></AddDialog>
            <AddDialog v-if="dialog.editVisible" :dialogVisible="dialog.editVisible" title="新增白名单" :whiteListData="dialog.item" @sure="sureEdit" @close="close" :loading="dialog.loading"></AddDialog>
            <unwhiteListDialogVue v-if="dialog.unWhiteVisible" :dialogVisible="dialog.unWhiteVisible" :whiteListData="whiteListData.whiteListConfig" @sure="sureUnWhite" @close="closeUnWhite" :loading = "dialog.loading"></unwhiteListDialogVue>
        </div>
    </div>
</template>
<script>
import AddDialog from '@/components/whiteList/addDialog.vue'
import unwhiteListDialogVue from '@/components/whiteList/unwhiteListDialog.vue'
export default {
    name: 'whiteList',
    components:{
        AddDialog,
        unwhiteListDialogVue
    },
    data() {
        return {
            query:{
                ip: '',
                status:"",
                limit: 10,
                page: 1,
            },
            whiteListData:{
                loading:false,
                total:0,
                pageSizesArr:[10,50,200,500],
                whiteListConfig:{},
            },
            table: {
                tableData: [],
                selectData:[],
            },
            dialog:{
                loading:false,
                addVisible:false,
                editVisible:false,
                unWhiteVisible:false,
                item:{},
                
            }
        }
    },
    mounted() {
        this.getData()
        this.getWhiteListConfig();
    },
    methods: {
        getData(){
            this.query.page = 1
            this.whiteListData.total = 0
            this.getWhiteList()
        },
        //获取非白名单核销次数
        getWhiteListConfig(){
            this.$api.getWhiteListConfig({}).then(res => { 
                console.log(res,'res')
                if(res.status == 1){
                    this.whiteListData.whiteListConfig = res.data;
                }else{
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 3 * 1000
                    });
                } 
            })
        },
        //获取白名单
        getWhiteList(){
            this.whiteListData.loading = true
            this.$api.getWhiteList(this.query).then(res => { 
                console.log(res,'res')
                this.whiteListData.loading = false;
                if(res.status == 1){
                    this.table.tableData = res.data.data;
                    this.whiteListData.total = res.data.total;
                }else{
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 3 * 1000
                    });
                } 
            }).catch(e=>{
                this.whiteListData.loading = false;
            })
        },
         // 分页查询数据
        handleSizeChange(val){
            this.query.limit = val;
            this.query.page = 1
            this.whiteListData.total = 0
            this.getWhiteList()
        },
        handleCurrentChange(val){
            this.query.page = val
            this.getWhiteList()
        },
        // 打开新增弹窗
        openAdd(){
            this.dialog.addVisible = true
            this.dialog.item = {ip:''}
        },
        //打开编辑弹窗
        openEdit(item){
            this.dialog.editVisible = true
            this.dialog.item = item
        },
        //批量删除
        batchDeleteData(){
            console.log(this.table.selectData ,'批量删除数据')
            this.$confirm(`确认删除选中的 ${this.table.selectData.length} 个白名单?`, '批量删除确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    let idsArr = this.table.selectData.map(item=>item.id)
                    let data ={
                        ids: idsArr.join(',')
                    }
                    this.batchDeleteWhiteList(data)
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });          
                });
           
        },
        //批量删除接口
        batchDeleteWhiteList(data){
            this.$api.batchDeleteWhiteList(data).then(res=>{
                if(res.status == 1){
                    this.getData()
                }else{
                    this.$message({
                        message:res.msg,
                        type:"error",
                        duration: 3 * 1000
                    })
                }
            })
        },
        //单个数据删除
        deleteData(item){
            console.log(item,'单个数据删除')
            this.deleteWhiteList(item);
        },
        //删除单个白名单接口
        deleteWhiteList(item){
            let data = {
                id:item.id
            }
            this.whiteListData.loading = true;
            this.$api.deleteWhiteList(data).then(res=>{
            this.whiteListData.loading = false;
                if(res.status == 1){
                    this.getData()
                }else{
                    this.$message({
                        message:res.msg,
                        type:"error",
                        duration: 3 * 1000
                    })
                }
            }).catch(e=>{
                
            this.whiteListData.loading = false;
            })
        },
        handleSelectionChange(val) {
            this.table.selectData = val
        },
        sure(formData){
            console.log(formData,'formData')
            let data = {
                ip_address:formData.ip_address
            }
            this.dialog.loading = true;
            this.$api.addWhiteList(data).then(res=>{
                this.dialog.loading = false;
                if(res.status == 1){
                    this.close();
                    this.getData();
                }else{
                    this.$message({
                        message:res.msg,
                        type:"error",
                        duration: 3 * 1000
                    })
                }
            }).catch(e=>{
                this.dialog.loading = false;
            })
        },
        sureEdit(formData){
            let data = { 
                id:formData.id,
                ip_address:formData.ip_address
            }
            this.dialog.loading = true;
            this.$api.editWhiteList(data).then(res=>{
                this.dialog.loading = false;
                if(res.status == 1){
                    this.close();
                    this.getData();
                }else{
                    this.$message({
                        message:res.msg,
                        type:"error",
                        duration: 3 * 1000
                    })
                }
            }).catch(e=>{
                this.dialog.loading = false;
            })
        },
        close(){
            this.dialog.addVisible = false
            this.dialog.editVisible = false
            this.dialog.item = {}
            this.dialog.loading = false
        },
        //打开非白名单核销次数弹窗
        openConfig(){
            this.dialog.unWhiteVisible = true
        },
        //关闭非白名单核销次数弹窗
        closeUnWhite(){
            this.dialog.unWhiteVisible = false
            this.dialog.loading = false
        },
        //非白名单核销次数保存
        sureUnWhite(formData){
            let data = {
                verify_limit:formData.verify_limit
            }
            this.dialog.loading = true;
            this.$api.updateWhiteListConfig(data).then(res=>{
                this.dialog.loading = false;
                if(res.status == 1){
                    this.closeUnWhite();                    
                    this.getWhiteListConfig();
                }else{
                    this.$message({
                        message:res.msg,
                        type:"error",
                        duration: 3 * 1000
                    })
                }
            }).catch(e=>{
                this.dialog.loading = false;
            })
        },
        //去停用  启用 白名单
        updateStatus(item){
            let status = item.status == 1 ? 0 : 1;
            let data = {
                id:item.id,
                status:status
            }
            this.whiteListData.loading = true;
            this.$api.changeWhiteListStatus(data).then(res=>{
                this.whiteListData.loading = false;
                if(res.status == 1){
                    this.getData();
                }else{
                    this.$message({
                        message:res.msg,
                        type:"error",
                        duration: 3 * 1000
                    })
                }
            }).catch(e=>{
                this.whiteListData.loading = false;
            })
        }

    }
}
</script>
<style lang="scss" scoped>
    .white-list-box{
        padding: 20px;
        .page-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px; 
            color: #303133;
            .settings-section {
                display: flex;
                align-items: center;
                gap: 12px;
                .setting-label {
                    color: #606266;
                    font-size: 14px;
                }
            }
        }
        .query-box{
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 16px;
            padding: 16px 20px;
            border-bottom: 1px solid #ebeef5;
            background-color: #fafcff;
            .query-btn-box{
                display: flex;
                gap: 12px;
            }
            .query-input-box{
                display: flex;
                align-items: center;
                .query-select{
                    width: 120px;
                }
                .query-input{
                    width: 180px;
                }
            }
        }
        .table-box{ 
            .pageBox{
                padding: 16px 20px;
                border-top: 1px solid #ebeef5;
                background-color: #fafcff;

            }
        }
        
    }
        
</style>